import React, {useEffect} from "react";
import { TextField } from "@mui/material";
import { ArrowBackIosNew } from "@mui/icons-material";
import { GridSaveAltIcon } from "@mui/x-data-grid";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Button, Modal, Grid, Stack, Typography, ModalClose, Sheet } from "@mui/joy";
import { Experimental_CssVarsProvider as CssVarsProvider } from "@mui/material/styles";
import ISetPassword from "../../types/set-password.type";

interface ModalProps {
  isOpen: boolean,
  onSubmit: (data: ISetPassword) => void,
  onClose: () => void,
}

const SetPasswordModal: React.FC<ModalProps> = (props) => {
  const { isOpen, onClose, onSubmit } = props;

  const initialValues: ISetPassword = {
    newPassword: '',
    confirmPassword: '',
  };

  const validationSchema = Yup.object({
    newPassword: Yup.string()
      .required('Indique su nueva contraseña.')
      .min(8, 'Password debe tener al menos 8 caracteres.')
      .matches(/[0-9]/, 'La contraseña debe tener al menos un numero.')
      .matches(/[a-z]/, 'La contraseña debe tener al menos una letra en minuscula.')
      .matches(/[A-Z]/, 'La contraseña debe tener al menos una letra en mayuscula.'),
    confirmPassword: Yup.string()
      .required('Indique nuevamente su nueva contraseña')
      .oneOf([Yup.ref('newPassword')], 'Las contraseñas deben coincidir')
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    onSubmit: onSubmit,
    validationSchema: validationSchema,
  });

  useEffect(() => {

  }, [isOpen]);

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Sheet
        variant="outlined"
        sx={{
          width: 730,
          borderRadius: 'md',
          p: 3,
          boxShadow: 'lg',
          maxHeight: 700
        }}
      >
        <ModalClose variant="plain" sx={{ m: 1 }} />
        <Typography level="h4" component="h1" sx={{ paddingLeft: 1 }}>
          Cambiar Contraseña
        </Typography>
        <form className="form" onSubmit={formik.handleSubmit}>
          <Grid
            container
            rowSpacing={2}
            columnSpacing={2}
            marginBlock={1}
            marginInline={0}
            sx={{ width: '100%' }}
          >

            <Grid xl={12} md={12} sm={12} xs={12}>
              <CssVarsProvider>
                <TextField
                  fullWidth
                  id="newPassword"
                  label="Nueva Contraseña"
                  name="newPassword"
                  variant="filled"
                  type={"password"}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.newPassword}
                  error={!!(formik.touched.newPassword && formik.errors.newPassword)}
                  slotProps={{ inputLabel: {shrink: true}}}
                />
                {formik.touched.newPassword && formik.errors.newPassword ? (
                  <span className="Error-alert">{formik.errors.newPassword}</span>
                ) : null}
              </CssVarsProvider>
            </Grid>

            <Grid xl={12} md={12} sm={12} xs={12}>
              <CssVarsProvider>
                <TextField
                  fullWidth
                  id="confirmPassword"
                  label="Confirmar Contraseñas"
                  name="confirmPassword"
                  variant="filled"
                  type={"password"}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.confirmPassword}
                  error={!!(formik.touched.confirmPassword && formik.errors.confirmPassword)}
                  slotProps={{ inputLabel: {shrink: true}}}
                />
                {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
                  <span className="Error-alert">{formik.errors.confirmPassword}</span>
                ) : null}
              </CssVarsProvider>
            </Grid>
          </Grid>
          <Stack direction="row" justifyContent="flex-end" spacing={2} sx={{paddingRight: 1}}>
            <Button variant="outlined" endDecorator={<ArrowBackIosNew />} onClick={onClose}>Cerrar</Button>
            <Button type="submit" variant="solid" endDecorator={<GridSaveAltIcon />}>Guardar</Button>
          </Stack>
        </form>
      </Sheet>
    </Modal>
  );
};

export default SetPasswordModal;
